<template>
  <div class="">
    <div>
      <input
          type="file"
          id="select_multiple_image"
          name="select_multiple_image"
          multiple
          :accept="acceptAttribute"
          class="d-none"
          @input="onFileChange">
      <label for="select_multiple_image" class="multi-image-picker multi-image-picker--empty  mb-2">
        <b-icon icon="images" class="multi-image-picker__icon"/>
        <span class="multi-image-picker__text">انتخاب تصاویر</span>
      </label>
    </div>
    <div>
      <div class="multi-image-grid mb-2">
        <div
            class="multi-image-grid__item"
            v-for="(file, index) in previews"
            :key="`${file}-${index}`">
          <div class="multi-image-thumb">
            <video controls class="multiple-image-input-video" :src="file" v-if="isFileVideo(file)"></video>
            <img :src="file" v-else class="multiple-image-input"/>

            <button
                @click="removeImage(index)"
                type="button"
                class="multi-image-thumb__remove"
                title="حذف">
              <b-icon icon="trash"/>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {supportedVideoFormats} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/SupportedVideoFormats";

export default {
  name: "MultiImageInput",
  props: {
    previews: {},
    imagesSelector: {},
    allowedExtensions: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      previewImages: this.preview,
      picProps: {
        blankColor: "#fff",
        class: "m1",
      },
    };
  },
  model: {
    prop: 'imagesSelector',
    event: 'input'
  },
  computed: {
    acceptAttribute() {
      if (!this.allowedExtensions || !this.allowedExtensions.length) {
        return 'image/*,video/*'
      }
      return this.allowedExtensions.map(ext => `.${ext}`).join(',')
    }
  },
  methods: {
    getExtension(file) {
      const name = (file && file.name) ? file.name : ''
      const parts = name.split('.')
      return parts.length > 1 ? parts[parts.length - 1] : ''
    },
    isAllowed(file) {
      if (!this.allowedExtensions || !this.allowedExtensions.length) {
        return true
      }
      return this.allowedExtensions.indexOf(this.getExtension(file)) > -1
    },
    removeImage(index) {
      // if have selected item(index) in images we remove it from server.

      const removeItemFromServe = this.previews[index].indexOf('blob') === -1;
      this.$emit('removeTempImage', (index - this.previews.length))
      this.previews.splice(index, 1);
      if (removeItemFromServe) {
        this.$store.dispatch("Product/deleteImage", index)
            .then(res => {
              this.$emit('removeImage', true)
            })
            .catch((error) => {
              console.log(error);
            })

      }

    },
    onFileChange(e) {
      const validFiles = []
      for (let i = 0; i < e.target.files.length; i++) {
        const file = e.target.files[i];
        if (!this.isAllowed(file)) {
          this.$emit('invalid-image', {file, extension: this.getExtension(file)})
          continue
        }
        this.previews.push(URL.createObjectURL(file));
        validFiles.push(file)
      }
      if (validFiles.length) {
        this.$emit('images', validFiles)
      }
      e.target.value = ''
    },
    isFileVideo(file) {
      file = file.split('.').slice(-1)[0];
      return supportedVideoFormats.indexOf(file) > -1
    }
  },
}
</script>

<style scoped>
.multi-image-picker {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0;
}

.multi-image-picker--empty {
  flex-direction: column;
  gap: 0.35rem;
  width: 120px;
  height: 120px;
  border: 1.5px dashed rgba(30, 30, 30, 0.18);
  border-radius: 16px;
  background: #f7f7f8;
  color: #6b6b6b;
  transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease;
}

.multi-image-picker--empty:hover {
  border-color: #eb3d60;
  color: #eb3d60;
  background: rgba(235, 61, 96, 0.04);
}

.multi-image-picker__icon {
  font-size: 1.75rem;
}

.multi-image-picker__text {
  font-size: 0.8rem;
  font-weight: 700;
}

.multi-image-thumb {
  position: relative;
  display: inline-block;
  border-radius: 12px;
  overflow: hidden;
}

.multi-image-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
  align-items: flex-start;
}

.multi-image-grid__item {
  flex: 0 0 auto;
}

.multi-image-thumb__remove {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: rgba(220, 37, 48, 0.92);
  color: #fff;
  cursor: pointer;
  z-index: 2;
}

.multi-image-thumb__remove:hover {
  background: #dc2530;
}

.multiple-image-input {
  object-fit: cover;
  height: 75px;
  width: 75px;
  border-radius: 12px;
  display: block;
}

.multiple-image-input-video {
  height: 150px;
  width: 150px;
  border-radius: 12px;
  display: block;
}

</style>
